import slideToggle from './utils/slideToggle.js';
import inlineCart from './globals/inline-cart.js';
import countdownTimer from './globals/countdown-timer.js';
import headerMegamenu from './globals/header-megamenu.js';
import scrollLockGutter from './globals/scroll-lock-gutter.js';

// Footer accordion functionality
const footerAccordion = () => {
  const accordions = document.querySelectorAll('.footer-accordion__header');

  accordions.forEach(accordion => {
    // Skip if already initialized
    if (accordion.dataset.listenerAttached === 'true') return;

    // Ensure there's a matching body
    const panel = accordion.nextElementSibling;
    if (!panel || !panel.classList.contains('footer-accordion__body')) return;

    // Show SVG icon
    const svg = accordion.querySelector('svg');
    if (svg) {
      svg.style.display = 'block';
    }

    accordion.addEventListener('click', function () {
      this.classList.toggle('active');
      slideToggle(panel, 300);
    });

    accordion.dataset.listenerAttached = 'true'; // mark as handled
  });
};

document.addEventListener("DOMContentLoaded", function () {
  footerAccordion();
  inlineCart();
  countdownTimer();
  headerMegamenu();
  scrollLockGutter();
});

